<template>
  <div>
	  <VideoControl @subcommand="subcommand"></VideoControl>
  </div>
</template>

<script>
import VideoControl from '../controls/VideoControl';
import BaseSlide from './BaseSlide';
export default {
	name: 'VideoSlide',
	mixins: [BaseSlide],
	components: {
		VideoControl,
	},
};
</script>

<style scoped></style>
